import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import WorkshopHeader from './WorkshopHeader';
import WorkshopNavTabBar from './WorkshopNavTabBar';
import WorkshopList from './WorkshopList';
import WorkshopFilterHeader from './WorkshopFilterHeader';
import { Toast } from '@repo/common';
import { getWorkshopSlotAdminList } from '../../../api/workshop/workshop.api';

const WorkshopManagement = () => {
  const [currentFilter, setCurrentFilter] = useState('By Date');
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [refreshKey, setRefreshKey] = useState(0);
  const [singleDeleteSlotId, setSingleDeleteSlotId] = useState(null);
  const [singleSoftDeleteSlotId, setSingleSoftDeleteSlotId] = useState(null);
  const [actionToast, setActionToast] = useState(null);
  const [appliedFilters, setAppliedFilters] = useState({
    sortBy: 'Start date (Newest first)',
    dateRange: 'All time',
    category: 'All categories',
    status: 'All Statuses',
  });
  const [showDeleteSuccessToast, setShowDeleteSuccessToast] = useState(null);

  const location = useLocation();

  useEffect(() => {
    if (location.state?.showToast) {
      setShowDeleteSuccessToast(false);
      setTimeout(() => setShowDeleteSuccessToast(true), 10);
    }
  }, [location.state]);

  const handleActionSuccess = (message) => {
    setRefreshKey((prev) => prev + 1);
    setActionToast(null);
    setTimeout(() => setActionToast(message), 10);
  };

  const handleFiltersApply = async (newFilters) => {
    await getWorkshopSlotAdminList({
      page: 0,
      size: 12,
      sortBy: newFilters.sortBy,
      dateRange: newFilters.dateRange,
      category: newFilters.category,
      status: newFilters.status,
    });
    setAppliedFilters(newFilters);
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <div className='flex flex-col w-full items-start'>
      <WorkshopHeader />
      <WorkshopNavTabBar />
      <WorkshopFilterHeader
        currentFilter={currentFilter}
        onFilterChange={setCurrentFilter}
        selectedIds={selectedIds}
        onDeleteSuccess={() => {
          setSelectedIds(new Set());
          setRefreshKey((prev) => prev + 1);
        }}
        singleDeleteSlotId={singleDeleteSlotId}
        onSingleDeleteDone={(deleted) => {
          setSingleDeleteSlotId(null);
          if (deleted) setRefreshKey((prev) => prev + 1);
        }}
        singleSoftDeleteSlotId={singleSoftDeleteSlotId}
        onSingleSoftDeleteDone={(deleted) => {
          setSingleSoftDeleteSlotId(null);
          if (deleted) setRefreshKey((prev) => prev + 1);
        }}
        appliedFilters={appliedFilters}
        onFiltersApply={handleFiltersApply}
      />
      <WorkshopList
        currentFilter={currentFilter}
        selectedIds={selectedIds}
        setSelectedIds={setSelectedIds}
        refreshKey={refreshKey}
        appliedFilters={appliedFilters}
        onDeletePermanentlyClick={(slotId) => setSingleDeleteSlotId(slotId)}
        onDeleteClick={(slotId) => setSingleSoftDeleteSlotId(slotId)}
        onActionSuccess={handleActionSuccess}
      />

      {actionToast && (
        <div className='fixed bottom-6 left-0 right-0 px-4 z-[1000] flex justify-center'>
          <div className='w-full' style={{ maxWidth: actionToast.width }}>
            <Toast
              title={actionToast.title}
              hierarchy='important'
              direction='up'
              customWidth='100%'
            />
          </div>
        </div>
      )}

      {showDeleteSuccessToast && (
        <div className='fixed bottom-6 left-0 right-0 px-4 z-[1000] flex justify-center'>
          <div className='w-full' style={{ maxWidth: '228px' }}>
            <Toast
              title={`Workshop deleted.`}
              hierarchy='important'
              direction='up'
              customWidth='100%'
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkshopManagement;
